import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {ConfigValidationFunction, AdditionalConfigValidationFunctions} from '../StepConfigValidationTypes';
import * as Helpers from './StepConfigValidationHelpers';

const validateConfig: ConfigValidationFunction<PipelineStepType.RETYPE_COLUMNS, 0> = (
  config,
  {'Input dataset': [dataFrameSpec]}
) => {
  const columns = config.retypeColumns.map((rc) => rc.column);
  const duplicateColumnsMsg = Helpers.getDuplicateColumnsMessage(
    dataFrameSpec,
    columns,
    'Cannot convert the same column more than once.'
  );
  const noColumnsMsg = columns.length >= 1 ? null : 'Must convert at least one column';
  return Helpers.coalesceMessages(duplicateColumnsMsg, noColumnsMsg);
};

export default {
  stepType: PipelineStepType.RETYPE_COLUMNS,
  stepVersion: 0,
  validateConfig,
} satisfies AdditionalConfigValidationFunctions<PipelineStepType.RETYPE_COLUMNS, 0>;
